import { FlowType } from "../../constants/FlowType";
import PrincipalFlowVerticalStepperElements from "../../constants/PrincipalFlowVerticalStepperElements";
import BackgroundInformationForm from "../shared/BackgroundInformation/BackgroundInformationForm";

export default function PrincipalBackgroundInformation() {
    return (
        <BackgroundInformationForm
            verticalStepperElements={PrincipalFlowVerticalStepperElements}
            flowType={FlowType.Principal}
            componentName="PrincipalBackgroundInformation"
        />
    );
}
